import { render } from "./GothBusinessList.vue?vue&type=template&id=77cdb6a6&scoped=true"
import script from "./GothBusinessList.vue?vue&type=script&lang=js"
export * from "./GothBusinessList.vue?vue&type=script&lang=js"

import "./GothBusinessList.vue?vue&type=style&index=0&id=77cdb6a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cdb6a6"]])

export default __exports__